// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"56810b50","580":"d076a53e"}[chunkId] + ".chunk.css";
};